'use strict';
angular.module('schoolLinqApp').factory('arBillingGroupService', [
	'$http',
	function ($http) {
		var endpoint = '/api/accounts-receivable/billing-groups';

		function getARBillingGroups() {
			return $http.get(endpoint);
		}

		function getARBillingGroup(id) {
			return $http.get(endpoint + '/' + id);
		}

		function addARBillingGroup(arBillingGroup) {
			return $http.post(endpoint, arBillingGroup);
		}

		function updateARBillingGroup(arBillingGroup) {
			return $http.put(endpoint + '/' + arBillingGroup.Id, arBillingGroup);
		}

		function deleteARBillingGroup(id) {
			return $http.delete(endpoint + '/' + id);
		}

		return {
			getARBillingGroups: getARBillingGroups,
			getARBillingGroup: getARBillingGroup,
			addARBillingGroup: addARBillingGroup,
			updateARBillingGroup: updateARBillingGroup,
			deleteARBillingGroup: deleteARBillingGroup,
		};
	},
]);
